import { useHistory } from "react-router-dom";
import { ReactComponent as Back } from "../img/icons/icon_blue_back.svg";

function NavigateBack({ onClickHandler = null, title = "" }) {
  const history = useHistory();

  const onClickFn = () => {
    if (onClickHandler) {
      onClickHandler();
    } else {
      history.goBack();
    }
  };

  return (
    <header className="border_bottom">
      <div className="inner_header">
        <div onClick={onClickFn} className="icon_left">
          <Back className="img-fluid" />
          <span className="head_title">{title}</span>
        </div>
      </div>
    </header>
  );
}

export default NavigateBack;
